import { DisplayClasses_DisplayClass_$ctor_Z207A3CFB } from "../Types/Display.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const Display = DisplayClasses_DisplayClass_$ctor_Z207A3CFB(new Property_CssProperty(93));

